import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'simpleDateFormat',
})
export class SimpleDateFormatPipe implements PipeTransform {
  transform(date: string, format: string = `YYYY-MM-DD HH:mm:ss`, currentFormat = ''): any {
    return moment(date, currentFormat).format(format);
  }
}
